import { gql } from '@apollo/client'
import { format } from 'date-fns'
import { ethers } from 'ethers'
import { useEffect, useState } from 'react'

import { MOONBEAM } from '../../config/chains'
import { SUBGRAPH_URLS } from '../../config/subgraphs'
import { GLP_DECIMALS } from '../const'
import { roundDownToNearestDay } from '../numbers'
import { createClient } from '../useClient'

export default function useGlpStats(params) {
  const [blpStats, setBlpStats] = useState([])
  const client = createClient(SUBGRAPH_URLS[MOONBEAM].stats)

  useEffect(() => {
    if (!params.fromValue || !params.toValue) {
      return
    }

    const start = roundDownToNearestDay(params.fromValue)
    const end = roundDownToNearestDay(params.toValue)

    const glpStatsQuery = gql`
      query dailyBlpPriceStats($start: Int!, $end: Int!) {
        glpStats(
          first: 1000
          orderBy: id
          orderDirection: asc
          where: { period: daily, id_gte: $start, id_lte: $end }
        ) {
          id
          glpSupply
          aumInUsdg
        }
      }
    `

    const getBlpStats = async () => {
      client
        .query({
          query: glpStatsQuery,
          variables: { start: start, end: end },
        })
        .then(({ data }) => {
          const { glpStats } = data
          const chartData = glpStats.map((el) => {
            const d = new Date(el.id * 1000)
            const aum = parseFloat(
              ethers.utils.formatUnits(el.aumInUsdg, GLP_DECIMALS)
            )
            const supply = parseFloat(
              ethers.utils.formatUnits(el.glpSupply, GLP_DECIMALS)
            )
            return {
              x: format(d, 'do MMM yyyy'),
              supply: supply,
              aum: aum,
              blpPrice: aum / supply
            }
          })

          setBlpStats(chartData)
        })
    }

    getBlpStats()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params])

  return blpStats
}
